import { useContext, useEffect } from 'react';

import { PageCardContext } from '../PageCardContext.ts';
import { QuickActionsEnum } from '../Items/QuickActions/QuickActionsEnum.ts';

export const useMenuState = (menuItem: any, isSelected: any): void => {
	const { setIsMenuOpen, setSelectedMenuItems, selectedMenuItems } = useContext(PageCardContext);
	useEffect(() => {
		setSelectedMenuItems({ ...selectedMenuItems, [menuItem]: isSelected });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSelected]);

	useEffect(() => {
		if (selectedMenuItems[QuickActionsEnum.WatchButton]) {
			setIsMenuOpen(true);
		} else {
			setIsMenuOpen(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedMenuItems]);
};
